(function() {
    const headerWrapper = document.querySelector('.header-wrapper');
    const submenuWrapper = document.getElementById('smk-submenu-wrapper');
    const navBtns = document.querySelectorAll('.smk-nav__item--submenu');
    const submenus = document.querySelectorAll('.smk-submenu');
    let current = null;

    function openSubmenu(name, btn) {
      current = name;
      headerWrapper.classList.add('smk-submenu-open');
      submenuWrapper.classList.add('is-open');
      submenus.forEach(s => {
        s.classList.toggle('is-active', s.dataset.submenu === name);
      });
      navBtns.forEach(b => {
        b.setAttribute('aria-expanded', b.dataset.submenu === name ? 'true' : 'false');
      });
      // ナビ項目の左位置にサブメニューリストを合わせる
      if (btn) {
        const btnRect = btn.getBoundingClientRect();
        const activePanel = submenuWrapper.querySelector(`.smk-submenu[data-submenu="${name}"]`);
        if (activePanel) {
          activePanel.style.paddingLeft = btnRect.left + 'px';
        }
      }
      // 検索パネルが開いたらinputにfocus
      if (name === 'search') {
        setTimeout(() => {
          const searchInput = document.getElementById('smk-search-input-panel');
          if (searchInput) searchInput.focus();
        }, 120);
      }
    }

    function closeSubmenu() {
      current = null;
      headerWrapper.classList.remove('smk-submenu-open');
      submenuWrapper.classList.remove('is-open');
      navBtns.forEach(b => b.setAttribute('aria-expanded', 'false'));
      // コンテンツはアニメーション完了後に非表示
      setTimeout(() => {
        submenus.forEach(s => s.classList.remove('is-active'));
      }, 380);
    }

    navBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        const name = this.dataset.submenu;
        if (current === name) {
          closeSubmenu();
        } else {
          openSubmenu(name, this);
        }
      });
    });

    // 写真ホバー
    document.querySelectorAll('.smk-submenu__item').forEach(item => {
      const panel = item.closest('.smk-submenu');
      const photoWrap = panel.querySelector('.smk-submenu__photo-wrap');
      const photoImg = panel.querySelector('.smk-submenu__photo-img');

      item.addEventListener('mouseenter', function() {
        const photo = this.dataset.photo;
        if (photo && photo !== 'undefined') {
          photoImg.src = photo;
          photoWrap.classList.add('is-visible');
        }
      });
      item.addEventListener('mouseleave', function() {
        photoWrap.classList.remove('is-visible');
      });
    });

    // 検索フォーム送信時にパネルを閉じる
    const searchForm = document.querySelector('.smk-submenu--search .smk-search-form');
    if (searchForm) {
      searchForm.addEventListener('submit', function() {
        closeSubmenu();
      });
    }

    // 外クリックで閉じる（モバイルメニュー内は除外）
    const mobileMenuWrap = document.getElementById('smk-mobile-menu-wrapper');
    document.addEventListener('click', function(e) {
      if (
        !headerWrapper.contains(e.target) &&
        !submenuWrapper.contains(e.target) &&
        !(mobileMenuWrap && mobileMenuWrap.contains(e.target))
      ) {
        closeSubmenu();
      }
    });
  })();
  // ================================================
  // MOBILE MENU（デスクトップsubmenuと同じ方式）
  // ================================================
  (function() {
    const mobileMenuWrapper = document.getElementById('smk-mobile-menu-wrapper');
    const headerWrapper = document.querySelector('.header-wrapper');
    const menuSummary = document.querySelector('header-drawer .header__icon--menu');
    const menuLabel = document.querySelector('.smk-menu-btn-label');

    if (!mobileMenuWrapper || !menuSummary) return;

    let isOpen = false;

    // Dawnのdetails開閉を無効化してカスタム制御に切り替え
    menuSummary.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      isOpen ? closeMobileMenu() : openMobileMenu();
    });

    function openMobileMenu() {
      isOpen = true;
      headerWrapper.classList.add('smk-submenu-open');
      mobileMenuWrapper.classList.add('is-open');
      menuLabel.textContent = 'Close';
    }

    function closeMobileMenu() {
      isOpen = false;
      headerWrapper.classList.remove('smk-submenu-open');
      mobileMenuWrapper.classList.remove('is-open');
      // アコーディオンを全て閉じる
      document.querySelectorAll('.smk-mnav__accordion.is-open').forEach(acc => {
        acc.classList.remove('is-open');
        const btn = document.querySelector(`[data-target="${acc.id}"]`);
        // icon unchanged
      });
      setTimeout(() => { menuLabel.textContent = 'Menu'; }, 380);
    }

    // アコーディオン開閉
    document.querySelectorAll('.smk-mnav__row--has-sub').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        const targetId = this.dataset.target;
        const accordion = document.getElementById(targetId);
        const icon = this.querySelector('.smk-mnav__icon');
        const isAccOpen = accordion.classList.contains('is-open');

        // 他を閉じる
        document.querySelectorAll('.smk-mnav__accordion.is-open').forEach(acc => {
          acc.classList.remove('is-open');
          const otherBtn = document.querySelector(`[data-target="${acc.id}"]`);
          // icon unchanged
          acc.querySelector('.smk-mnav__photo-wrap').classList.remove('is-visible');
        });

        if (!isAccOpen) {
          accordion.classList.add('is-open');
          // 最初のアイテムの写真をデフォルト表示
          const firstItem = accordion.querySelector('.smk-mnav__subitem');
          const photoWrap = accordion.querySelector('.smk-mnav__photo-wrap');
          const photoImg = accordion.querySelector('.smk-mnav__photo-img');
          if (firstItem && firstItem.dataset.photo) {
            photoImg.src = firstItem.dataset.photo;
            setTimeout(() => photoWrap.classList.add('is-visible'), 200);
          }
        }
      });
    });

    // モバイル検索インライン
    const mobileSearchWrap = document.getElementById('smk-mobile-search-wrap');
    const mobileSearchInput = document.getElementById('smk-mobile-search-input');
    if (mobileSearchInput && mobileSearchWrap) {
      mobileSearchInput.addEventListener('focus', function() {
        mobileSearchWrap.classList.add('is-active');
      });
      mobileSearchInput.addEventListener('blur', function() {
        // キーワードクリックを優先するため少し遅らせてから閉じる
        setTimeout(function() {
          if (document.activeElement !== mobileSearchInput) {
            if (!mobileSearchInput.value.trim()) {
              mobileSearchWrap.classList.remove('is-active');
            }
          }
        }, 200);
      });
    }

    // タッチで写真を切り替え（touchmove で指が触れたアイテムを検知）
    document.querySelectorAll('.smk-mnav__sublist').forEach(sublist => {
      sublist.addEventListener('touchmove', function(e) {
        const touch = e.touches[0];
        const el = document.elementFromPoint(touch.clientX, touch.clientY);
        const item = el ? el.closest('.smk-mnav__subitem') : null;
        if (!item || !item.dataset.photo) return;
        const accordion = sublist.closest('.smk-mnav__accordion');
        if (!accordion) return;
        const photoImg = accordion.querySelector('.smk-mnav__photo-img');
        const photoWrap = accordion.querySelector('.smk-mnav__photo-wrap');
        if (photoImg.src !== item.dataset.photo) {
          photoImg.src = item.dataset.photo;
          photoWrap.classList.add('is-visible');
        }
      }, { passive: true });
    });
  })();

  // ================================================
  // CART COUNT SYNC
  // Dawn の section render が #cart-icon-bubble を上書きした後も
  // smk-cart-text を正しく保持・更新する
  // ================================================
  (function() {
    const cartBubble = document.getElementById('cart-icon-bubble');
    if (!cartBubble) return;

    let updating = false;

    function syncCartText() {
      if (updating) return;
      updating = true;

      // cart-count-bubble 内のカウントを取得（hidden でも読める）
      const countEl = cartBubble.querySelector('.cart-count-bubble [aria-hidden="true"]');
      const count = countEl ? (parseInt(countEl.textContent.trim()) || 0) : 0;

      // smk-cart-text が消えていたら再生成
      let textEl = cartBubble.querySelector('.smk-cart-text');
      if (!textEl) {
        textEl = document.createElement('span');
        textEl.className = 'smk-cart-text';
        cartBubble.prepend(textEl);
      }
      textEl.textContent = 'Cart (' + count + ')';

      setTimeout(function() { updating = false; }, 0);
    }

    const observer = new MutationObserver(syncCartText);
    observer.observe(cartBubble, { childList: true, subtree: true });
  })();


// First-use mobile guidance. No polling, extra requests, or animation library.
(function () {
  const init = () => {
    if (window.Shopify?.designMode || !window.matchMedia('(max-width: 1023px)').matches) return;
    const mobile = window.matchMedia('(max-width: 1023px)');
    const seen = key => { try { return sessionStorage.getItem(key) === '1'; } catch { return false; } };
    const remember = key => { try { sessionStorage.setItem(key, '1'); } catch { /* Memory still prevents repeats. */ } };
    const blocked = () => document.hidden || document.body.classList.contains('smk-cart-drawer-open') ||
      Boolean(document.querySelector('.header-wrapper.smk-submenu-open, #smk-mobile-menu-wrapper.is-open'));

    const guides = Array.from(document.querySelectorAll('[data-smk-nav-guide]'));
    const navKey = 'smk:nav-guides:v1';
    const navEvents = new AbortController();
    let timer, revealFrame, activeGuide, guidesStarted = false;
    const stopGuides = () => {
      clearTimeout(timer);
      cancelAnimationFrame(revealFrame);
      guides.forEach(guide => { guide.hidden = true; });
      activeGuide = null; navEvents.abort();
    };
    const positionGuide = (guide, target) => {
      const rect = target.getBoundingClientRect();
      if (!rect.width || getComputedStyle(target).visibility === 'hidden') return false;
      guide.style.right = (window.innerWidth - rect.left + 12) + 'px';
      guide.style.top = (rect.top + (rect.height - 26) / 2) + 'px';
      guide.style.maxWidth = Math.max(0, rect.left - 28) + 'px';
      return rect.left > 28;
    };
    const showGuide = index => {
      if (!mobile.matches || blocked() || index >= guides.length) { stopGuides(); return; }
      const guide = guides[index];
      const target = document.querySelector(guide.dataset.smkNavGuide === 'cart' ? '#cart-icon-bubble' : '.smk-saved-trigger--nav');
      if (!target || !positionGuide(guide, target)) { showGuide(index + 1); return; }
      const ribbon = document.querySelector('.smk-news-ribbon');
      const text = ribbon?.querySelector('.smk-news-ribbon-text');
      if (ribbon && text) {
        const background = getComputedStyle(ribbon), typography = getComputedStyle(text);
        guide.style.backgroundColor = background.backgroundColor;
        guide.style.boxShadow = background.boxShadow;
        for (const property of ['color', 'fontSize', 'fontWeight', 'lineHeight']) guide.style[property] = typography[property];
      }
      const label = guide.querySelector('.smk-mobile-guide__text');
      activeGuide = guide;
      guide.style.transition = 'none'; guide.style.width = '0'; guide.style.opacity = '0';
      guide.classList.remove('is-text-visible'); guide.hidden = false;
      // Measure once. Only this fixed ribbon changes width; surrounding content stays put.
      const width = Math.ceil(label.getBoundingClientRect().width);
      guide.style.transition = ribbon?.style.transition || 'width 0.8s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.4s ease';
      const revealGuide = () => {
        if (navEvents.signal.aborted) return;
        guide.style.width = width + 'px'; guide.style.opacity = '1';
        remember(navKey);
        timer = setTimeout(() => {
          guide.classList.add('is-text-visible');
          timer = setTimeout(() => {
            guide.classList.remove('is-text-visible');
            timer = setTimeout(() => {
              guide.style.width = '0'; guide.style.opacity = '0';
              timer = setTimeout(() => {
                guide.hidden = true; activeGuide = null; showGuide(index + 1);
              }, 800);
            }, 500);
          }, 1500);
        }, 500);
      };
      // Paint the zero-width ribbon first, so its first appearance also transitions.
      // Keep the free-shipping ribbon's motion in both OS motion modes (user request).
      revealFrame = requestAnimationFrame(() => { revealFrame = requestAnimationFrame(revealGuide); });
    };
    const startGuides = () => {
      if (guidesStarted || document.querySelector('[data-smk-ribbon-running="true"]')) return;
      guidesStarted = true;
      timer = setTimeout(() => showGuide(0), 300);
    };
    if (guides.length && !seen(navKey)) {
      const options = {signal: navEvents.signal};
      document.addEventListener('smk:news-ribbon-finished', startGuides, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) stopGuides(); }, options);
      document.addEventListener('pointerdown', event => {
        if (event.target.closest('header-drawer, [data-smk-saved-open], [data-smk-account-open], #cart-icon-bubble')) stopGuides();
      }, {...options, passive: true});
      window.addEventListener('resize', () => {
        if (!mobile.matches) stopGuides();
        else if (activeGuide) positionGuide(activeGuide, document.querySelector(activeGuide.dataset.smkNavGuide === 'cart' ? '#cart-icon-bubble' : '.smk-saved-trigger--nav'));
      }, options);
      window.addEventListener('pagehide', stopGuides, {...options, once: true});
      startGuides();
    }

    // User-requested swipe hint keeps its motion in both OS motion settings.
    const swipeKey = 'smk:swipe-hint:v2';
    if (seen(swipeKey) || !window.IntersectionObserver || !Element.prototype.animate) return;
    const pending = new Map(), playing = new Set();
    const swipeEvents = new AbortController();
    let observer;
    const done = () => {
      if (!pending.size && !playing.size) { observer.disconnect(); swipeEvents.abort(); }
    };
    document.querySelectorAll('smk-item-carousel-01').forEach(host => {
      const track = host.querySelector('.smk-item-carousel__track');
      if (!track || track.querySelectorAll('.smk-item-carousel__item').length <= 2) return;
      const events = new AbortController();
      const state = {host, track, events, animation: null};
      state.cancel = () => {
        state.animation?.cancel(); observer?.unobserve(track.parentElement);
        pending.delete(track.parentElement); playing.delete(state); events.abort(); done();
      };
      const interacted = state.cancel;
      for (const type of ['pointerdown', 'wheel', 'focusin']) host.addEventListener(type, interacted, {passive: true, signal: events.signal});
      pending.set(track.parentElement, state);
    });
    if (!pending.size) return;
    observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.45 || blocked()) continue;
        const state = pending.get(entry.target); if (!state) continue;
        pending.delete(entry.target); playing.add(state); remember(swipeKey);
        observer.disconnect();
        // One visible section teaches the gesture; retire every other candidate.
        [...pending.values()].forEach(other => other.cancel());
        const base = getComputedStyle(state.track).transform;
        const transform = base === 'none' ? '' : base;
        state.animation = state.track.animate([
          {transform: transform + ' translateX(0)'},
          {transform: transform + ' translateX(-' + (entry.target.clientWidth / 3) + 'px)', offset: 0.45},
          {transform: transform + ' translateX(0)'}
        ], {duration: 1400, easing: 'ease-in-out'});
        state.animation.finished.then(state.cancel, () => {});
        break;
      }
      done();
    }, {threshold: 0.45});
    pending.forEach((state, target) => observer.observe(target));
    const stopSwipes = () => { [...pending.values(), ...playing].forEach(state => state.cancel()); };
    const options = {signal: swipeEvents.signal};
    document.addEventListener('visibilitychange', () => { if (document.hidden) stopSwipes(); }, options);
    const initialWidth = window.innerWidth;
    window.addEventListener('resize', () => { if (window.innerWidth !== initialWidth) stopSwipes(); }, options);
    window.addEventListener('pagehide', stopSwipes, {...options, once: true});
  };
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
